import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckToken from "../../_Login/CheckToken";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import GetOiler from "../Tools/OilerGetOiler";
import CompassBanner from "../../Tools/CompassBanner";
import CompassLogo from "../../Tools/CompassLogo";

const OilerConfigrationPrint = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [oiler, setOiler] = useState({});
    const [configuration, setConfiguration] = useState({});
    const [headers, setHeaders] = useState([]);
    const [tests, setTests] = useState([]);
    const [allowedDeviation, setAllowedDeviation] = useState(15);

    const response88 = useInvoke("WebApps", "88", { "@ConfigID": id });
    const response93 = useInvoke("WebApps", "93", { "@ConfigID": id });
    const response94 = useInvoke("WebApps", "94", { "@ConfigID": id });

    useEffect(() => {
        if (response88.data.payload !== undefined) {
            const myConfig = JSON.parse(response88.data.payload).data;
            let obj = {
                ConfigID: myConfig[0][0],
                OilID: myConfig[0][1],
                OilName: myConfig[0][2],
                CustomerBlankNum: myConfig[0][3],
                Length: myConfig[0][4],
                Width: myConfig[0][5],
                Speed: myConfig[0][6],
                Coverage: myConfig[0][7],
                NumberOfBlanks: myConfig[0][8],
                OilTemp: myConfig[0][9],
                AsShipped: myConfig[0][10],
                OilerID: myConfig[0][11],
                OilDescription: myConfig[0][12],
                OilViscosity: myConfig[0][13]
            };
            setConfiguration(obj);
        }

        if (response93.data.payload !== undefined) {
            const myHeaders = JSON.parse(response93.data.payload).data;
            const headersList = myHeaders.map(header => ({
                HeaderID: header[0],
                ConfigID: header[1],
                Location: header[2],
                FlowSP: header[3],
                OuterBar: {
                    SprayVoltage: header[4],
                    RestingVoltage: header[5],
                    IdleVoltage: header[6]
                },
                CenterBar: {
                    SprayVoltage: header[7],
                    RestingVoltage: header[8],
                    IdleVoltage: header[9]
                },
                Nozzle: {
                    SprayVoltage: header[10],
                    RestingVoltage: header[11],
                    IdleVoltage: header[12]
                },
                Boost: {
                    SprayVoltage: header[13],
                    RestingVoltage: header[14],
                    IdleVoltage: header[15]
                },
                HighVoltage: {
                    OnTime: header[16],
                    OffTime: header[17]
                },
                NozzleTimes: {
                    OnTime: header[18],
                    OffTime: header[19]
                }
            }));
            setHeaders(headersList);
        }

        if (response94.data.payload !== undefined) {
            const myTests = JSON.parse(response94.data.payload).data;
            let testsList = [];

            myTests.forEach(test => {
                let obj = {
                    TestID: test[0],
                    ConfigID: test[1],
                    TestNum: test[2],
                    BlankNum: test[3],
                    TopValue: test[4],
                    BottomValue: test[5],
                    Position: test[6]
                };

                testsList.push(obj);
            });

            // Sort the tests by position, blank num, and then test num
            testsList.sort((a, b) => {
                if (a.Position > b.Position) return 1;
                if (a.Position < b.Position) return -1;
                if (a.BlankNum > b.BlankNum) return 1;
                if (a.BlankNum < b.BlankNum) return -1;
                if (a.TestNum > b.TestNum) return 1;
                if (a.TestNum < b.TestNum) return -1;
                return 0;
            });

            setTests(testsList);
        }

    }, [response88.data.payload, response93.data.payload, response94.data.payload]);

    useEffect(() => {
        if (configuration["OilerID"] !== undefined) {
            GetOiler(configuration["OilerID"]).then((result) => {
                if (result !== undefined) {
                    const myOiler = JSON.parse(result.payload).data;
                    let obj = {
                        OilerID: myOiler[0][0],
                        JobNum: myOiler[0][1],
                        SiteAddressID: myOiler[0][2],
                        NumTestPoints: myOiler[0][3],
                        InFeedSensorDistance: myOiler[0][4],
                        CustomerID: myOiler[0][5],
                        CustomerName: myOiler[0][6],
                        CustomerAddress: myOiler[0][7],
                        CityStateZip: myOiler[0][8],
                        SiteName: myOiler[0][9],
                        SiteAddressName: myOiler[0][10],
                        SiteCityStateZip: myOiler[0][11],
                        DateCreated: myOiler[0][12],
                        CreatedByID: myOiler[0][13],
                        CreatedByName: myOiler[0][14],
                        Notes: myOiler[0][15]
                    };
                    setOiler(obj);
                }
            });
        }

    }, [configuration]);

    const getToday = (e) => {

        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const year = String(today.getFullYear());

        return `${month}/${day}/${year}`;

    };

    const handlePrint = () => {
        window.print();
    };

    const thStyle = { padding: "8px", border: "1px solid black", width: "25%", textAlign: "left" };
    const tdStyle = { padding: "8px", border: "1px solid black", width: "25%", textAlign: "center" };

    const thStyleSm = { padding: "8px", border: "1px solid black", width: "10%", textAlign: "center" };
    const tdStyleSm = { padding: "8px", border: "1px solid black", width: "10%", textAlign: "center" };

    document.title = `Print - Config ${id}`;
    return (
        <>
            <div className="body-content" style={{ marginTop: "25px", width: "1100px", margin: "auto", display: "flex", flexDirection: "column" }}>

                <div className="no-print" style={{ marginBottom: "8px" }}>
                    <Link to={`/Oilers/Configuration/${id}`} className="btn btn-default" style={{ width: "132px" }}>Back</Link>
                    <button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
                </div>

                <div style={{ border: "1px solid black", textAlign: "center", padding: "8px" }}>
                    {/* <CompassBanner /> */}
                    <CompassLogo />
                </div>

                <div style={{ color: "lightgray" }}>
                    <i>Report generated on {getToday()}</i>
                </div>

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                    <h3>Electrostatic Oiler Unit Configuration & Tests</h3>
                    <span style={{ color: "red", fontWeight: "bold" }}><i>[CONFIDENTIAL]</i></span>

                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <h4>Oiler Details</h4>

                    <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                        <tbody>
                            <tr>
                                <th style={thStyle}>
                                    Oiler ID
                                </th>
                                <td style={tdStyle}>
                                    {oiler["OilerID"]}
                                </td>
                                <th style={thStyle}>
                                    Date Created
                                </th>
                                <td style={tdStyle}>
                                    {oiler["DateCreated"]}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>
                                    Job Number
                                </th>
                                <td style={tdStyle}>
                                    {oiler["JobNum"]}
                                </td>
                                <th style={thStyle}>
                                    Created By
                                </th>
                                <td style={tdStyle}>
                                    {oiler["CreatedByName"]}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>
                                    # Test Points
                                </th>
                                <td style={tdStyle}>
                                    {oiler["NumTestPoints"]}
                                </td>
                                <th style={thStyle}>
                                    Infeed Sensor Distance <span style={{ color: "var(--bs-secondary)" }}>(in)</span>
                                </th>
                                <td style={tdStyle}>
                                    {oiler["InFeedSensorDistance"]}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle} colSpan={1}>
                                    Oiler Notes
                                </th>
                                <td style={tdStyle} colSpan={3}>
                                    {oiler["Notes"]}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Customer Details</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>
                                        Customer Name
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["CustomerName"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>
                                        JB Customer ID
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["CustomerID"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>
                                        Customer Address
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["CustomerAddress"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>
                                        Customer City, State, Zip
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["CityStateZip"]}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Site Location</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>
                                        Site Name
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["SiteName"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>
                                        Site Address
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["SiteAddressName"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>
                                        Site City, State, Zip
                                    </th>
                                    <td style={tdStyle}>
                                        {oiler["SiteCityStateZip"]}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Configuration Details</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Configuration ID</th>
                                    <td style={tdStyle}>
                                        {configuration["ConfigID"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}># Blanks</th>
                                    <td style={tdStyle}>
                                        {configuration["NumberOfBlanks"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Customer Blank #</th>
                                    <td style={tdStyle}>
                                        {configuration["CustomerBlankNum"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Length <span style={{ color: "var(--bs-secondary)" }}>(mm)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["Length"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Width <span style={{ color: "var(--bs-secondary)" }}>(mm)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["Width"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Speed <span style={{ color: "var(--bs-secondary)" }}>(fpm)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["Speed"]}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Oil</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Coverage Target <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["Coverage"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Name</th>
                                    <td style={tdStyle}>
                                        {configuration["OilName"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Temp <span style={{ color: "var(--bs-secondary)" }}>(°C)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["OilTemp"]}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Viscosity <span style={{ color: "var(--bs-secondary)" }}>(cSt)</span></th>
                                    <td style={tdStyle}>
                                        {configuration["OilViscosity"]}
                                    </td>
                                </tr>

                                <tr>
                                    <th style={thStyle} colSpan={1}>Oil Description</th>
                                    <td style={{ ...tdStyle, height: "72px" }} colSpan={3}>
                                        {configuration["OilDescription"]}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <h4>Header Details</h4>
                    {/* Seperate tables for upper and lower headers*/}

                    {
                        headers.map((header, index) => {
                            return (
                                <table key={index} className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                                    <tbody>
                                        <tr>
                                            <td style={thStyle} colSpan={2}>
                                                <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                                                    {header["Location"]} Header
                                                </span>
                                            </td>
                                            <th style={thStyle}>
                                                Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                {header["FlowSP"]}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style={thStyle}>
                                                Outer Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Spray</span>
                                                        <span>{header["OuterBar"]["SprayVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Resting</span>
                                                        <span>{header["OuterBar"]["RestingVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Idle</span>
                                                        <span>{header["OuterBar"]["IdleVoltage"]}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <th style={thStyle}>
                                                Center Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Spray</span>
                                                        <span>{header["CenterBar"]["SprayVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Resting</span>
                                                        <span>{header["CenterBar"]["RestingVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Idle</span>
                                                        <span>{header["CenterBar"]["IdleVoltage"]}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style={thStyle}>
                                                Nozzle <span style={{ color: "var(--bs-secondary)" }}>(kV)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Spray</span>
                                                        <span>{header["Nozzle"]["SprayVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Resting</span>
                                                        <span>{header["Nozzle"]["RestingVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Idle</span>
                                                        <span>{header["Nozzle"]["IdleVoltage"]}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <th style={thStyle}>
                                                Boost <span style={{ color: "var(--bs-secondary)" }}>(kV)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Spray</span>
                                                        <span>{header["Boost"]["SprayVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Resting</span>
                                                        <span>{header["Boost"]["RestingVoltage"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Idle</span>
                                                        <span>{header["Boost"]["IdleVoltage"]}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style={thStyle}>
                                                High Voltage <span style={{ color: "var(--bs-secondary)" }}>(ms)</span>
                                            </th>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>On Time</span>
                                                        <span>{header["HighVoltage"]["OnTime"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Off Time</span>
                                                        <span>{header["HighVoltage"]["OffTime"]}</span>
                                                    </div>
                                                </div>

                                            </td>
                                            <th style={thStyle} colSpan={1}>
                                                Nozzle Times <span style={{ color: "var(--bs-secondary)" }}>(ms)</span>
                                            </th>
                                            <td style={tdStyle} colSpan={3}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>On Time</span>
                                                        <span>{header["NozzleTimes"]["OnTime"]}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                        <span>Off Time</span>
                                                        <span>{header["NozzleTimes"]["OffTime"]}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            );
                        }
                        )}
                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <h4>Tests</h4>

                    <table className="no-break table" style={{ border: "1px solid black", width: "100%", marginTop: "24px" }}>
                        <thead>
                            <tr>
                                <th style={thStyleSm}>
                                    Position
                                </th>
                                <th style={thStyleSm}>
                                    Blank #
                                </th>
                                <th style={thStyleSm}>
                                    Test #
                                </th>
                                <th style={thStyleSm}>
                                    Coverage Target <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span>
                                </th>
                                <th style={thStyleSm}>
                                    Top Value / Deviation <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span>
                                </th>
                                <th style={thStyleSm}>
                                    Bottom Value / Deviation <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tests.map((test, index) => {

                                    const topDeviation = test["TopValue"] - configuration["Coverage"];
                                    const bottomDeviation = test["BottomValue"] - configuration["Coverage"];
                                    return (
                                        <tr key={index} >
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {test["Position"]}
                                            </td>
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {test["BlankNum"]}
                                            </td>
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {test["TestNum"]}
                                            </td>
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {configuration["Coverage"]}
                                            </td>
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {Math.abs(topDeviation) > 15 && <span>⚠ </span>}
                                                {test["TopValue"]} ({topDeviation > 0 ? `+${topDeviation}` : topDeviation})
                                            </td>
                                            <td style={{ ...tdStyleSm, textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                {Math.abs(bottomDeviation) > 15 && <span>⚠ </span>}
                                                {test["BottomValue"]} ({bottomDeviation > 0 ? `+${bottomDeviation}` : bottomDeviation})
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>

                </div>

            </div >
        </>
    );
}

export default OilerConfigrationPrint;